function getDefaultState() {
  return {
    addedBy: "gcommhub.synergyhousing.com",
    googleCommHubUrl: process.env.VUE_APP_API_URL,
    googleFormTypeUID: "c532572d-33a4-40dd-801b-ea13161a2036",
    urlCommunicationUID: "",
    urlFormTypeUID: "",
    emailTemplateID: "",
    images: {
      topLeftImage: "sgh.png",
      topRightImage: "blank.png",
    },
    errorMessage:
      "<div class='col-12 text-center'>Sorry, there was an error.<br />Please refresh and try again.<br />Thank you.</div>",
    successMessage:
      "<div class='col-12 text-center'>The survey has been submitted successfully.<br />Thank you.</div>",
  };
}

export default {
  namespaced: true,
  state: getDefaultState(),
  actions: {},
  getters: {},
  mutations: {
    changeImages(state, newImage) {
      state.images.topLeftImage = newImage.topLeftImage;
      state.images.topRightImage = newImage.topRightImage;
    },
  },
}
